import { PerfilEnum } from "../enums/perfil-enum";

export class Usuario {

    username: string = '';

    name: string = '';

    enabled: boolean = false;

    perfil: PerfilEnum = PerfilEnum.USUARIO;

    password: string = '';

    confirmPassword: string = '';

    novoPassword: string = '';

    constructor() {
    }
}
